module.exports = __webpack_public_path__ + "static/img/fysq_pic.f1bc8a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fysq_pic.png
// module id = vqRT
// module chunks = 181